module.exports = __webpack_public_path__ + "media/images/blue-checkbox-checked-20e30ccd39b75ccd2094a55a73e465e4.svg";